<template>
  <div class="w-full min-w-full h-screen flex overflow-hidden bg-cool-gray-100">
    <Sidebar
      class="w-2/12"
    />

    <div class="w-10/12">
      <Header />
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from '@/app/shared/components/layout/menu/header.vue';
import Sidebar from '@/app/shared/components/layout/menu/sidebar.vue';

export default {
  name: 'Dashboard',

  components: {
    Header,
    Sidebar,
  },

  mounted() {
    // Ensure clubs are loaded when dashboard mounts
    if (this.$store.state.user.isAuthenticated && this.$store.state.club.availableClubs.length === 0) {
      this.$store.dispatch('getAvailableClubs');
    }
  },

};
</script>
